import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import styles from './header-wrapper.module.css';

/**
 * @deprecated Wraper is deprecated
 */

export const Wrapper: FC<PropsWithChildren & { className?: string }> = ({
  children,
  className = false,
}) => {
  return <div className={clsx(styles.root, className)}>{children}</div>;
};
